import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";
export const ProdutoList = props => <DefaultDataTable data={props} />;
